export default "__VITE_ASSET__CYSIzR$___"